import script from "./WithdrawsApply.vue?vue&type=script&lang=ts&setup=true"
export * from "./WithdrawsApply.vue?vue&type=script&lang=ts&setup=true"

import "./WithdrawsApply.vue?vue&type=style&index=0&id=d9c22ac4&lang=scss"

const __exports__ = script;

export default __exports__